import React, { useState } from "react";
import { Alert, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { formatDateTimeEs } from "../../../utils/formatters";
import { getDetalleExportacionEoer } from "../../../services/exportacionesEoer";

const labels = { ejecutando: "En curso", completada: "Completada", parcial: "Parcial", error: "Error", interrumpida: "Interrumpida" };

export function HistorialExportacionesEoer({ status }) {
	const [detail, setDetail] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const showDetail = async (id) => {
		setLoading(true);
		setError("");
		try {
			const response = await getDetalleExportacionEoer(id);
			if (!response.success) throw new Error();
			setDetail({ id, items: response.details });
		} catch {
			setError("No se pudo cargar el detalle de la exportación.");
		} finally { setLoading(false); }
	};
	return (
		<Box sx={{ px: 2, pb: 2, width: "100%" }}>
			{status.error ? <Alert severity="warning" sx={{ mb: 2 }}>{status.error}</Alert> : status.running && (
				<Alert severity="info" sx={{ mb: 2 }}>Hay una exportación a EOER en curso. Puedes consultar su avance aquí aunque la petición dé timeout o recargues la página.</Alert>
			)}
			<Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
				<Typography variant="h6">Historial de exportaciones a EOER</Typography>
				<Button size="small" onClick={status.refresh}>Actualizar estado</Button>
			</Box>
			<TableContainer component={Paper} variant="outlined">
				<Table size="small">
					<TableHead><TableRow>
						{["Inicio", "Operador", "Acción", "Estado", "Procesados", "Enviados", "Ya enviados / omitidos", "Errores / sin confirmar", "Resultado"].map((label) => <TableCell key={label}>{label}</TableCell>)}
					</TableRow></TableHead>
					<TableBody>
						{status.historial.map((row) => <TableRow key={row.id}>
							<TableCell>{formatDateTimeEs(row.fecha_inicio)}</TableCell>
							<TableCell>{row.iniciado_por_nombre || "—"}</TableCell>
							<TableCell>{row.accion === "clear" ? "Limpiar preparación" : "Exportar"}</TableCell>
							<TableCell><Chip size="small" label={labels[row.estado] || row.estado} color={row.estado === "completada" ? "success" : row.estado === "ejecutando" ? "info" : "warning"} /></TableCell>
							<TableCell>{row.procesados} / {row.total}</TableCell>
							<TableCell>{row.enviados}</TableCell>
							<TableCell>{row.omitidos}</TableCell>
							<TableCell>{row.errores} / {row.inciertos}</TableCell>
							<TableCell>{row.resumen || "Procesando…"}<Button size="small" disabled={loading} onClick={() => showDetail(row.id)}>Ver fichajes</Button></TableCell>
						</TableRow>)}
						{!status.historial.length && <TableRow><TableCell colSpan={9}>Todavía no hay exportaciones registradas.</TableCell></TableRow>}
					</TableBody>
				</Table>
			</TableContainer>
			{error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
			<Dialog open={Boolean(detail)} onClose={() => setDetail(null)} maxWidth="md" fullWidth>
				<DialogTitle>Fichajes de la exportación #{detail?.id}</DialogTitle>
				<DialogContent>
					<Table size="small">
						<TableHead><TableRow><TableCell>Parte</TableCell><TableCell>Usuario</TableCell><TableCell>Resultado</TableCell></TableRow></TableHead>
						<TableBody>{detail?.items.map((item, index) => <TableRow key={index}>
							<TableCell>{item.id_cuadrilla || "—"}</TableCell><TableCell>{item.id_usuario || "—"}</TableCell><TableCell>{item.message}</TableCell>
						</TableRow>)}</TableBody>
					</Table>
				</DialogContent>
				<DialogActions><Button onClick={() => setDetail(null)}>Cerrar</Button></DialogActions>
			</Dialog>
		</Box>
	);
}
